import axios from 'axios'
import { formatMinutesToTimezone } from '../helpers/date.functions'
import { CookieManager, CookieName } from './cookie-service'
import { AppRoutes } from '../app-routes'
import { isClerkOfflineError } from '../providers/clerk/clerk-errors'

// Clerk authentication interceptor
// Gets JWT token from Clerk session and adds it to Authorization header

axios.interceptors.request.use(async (config) => {
  try {
    // Get token from Clerk session
    const token = await window.Clerk?.session?.getToken()

    if (token) {
      CookieManager.set(CookieName.AuthToken, token)
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${token}`
    }

    config.headers['X-Time-Zone'] = formatMinutesToTimezone(new Date().getTimezoneOffset())
  } catch (error) {
    if (isClerkOfflineError(error)) {
      // Offline is not signed out: fail this request and keep the session.
      console.warn('Clerk token unavailable while offline:', error)
      throw error
    }
    console.error('Failed to get Clerk token:', error)
    // Redirect to in-app login if no session
    window.location.assign(AppRoutes.Login())
  }
  return config
})

export default axios
